import { CatalogProgram, CatalogCollege, CatalogExam } from "../../types/catalog.response";
import { cacheGet } from "../../utils/cacheGet";

export const catalogApi = {
    getPrograms: async (): Promise<CatalogProgram[]> => {
        const response = await cacheGet('/catalog/programs', 3600); // 缓存1小时
        return response.data.data;
    },
    getColleges: async (): Promise<CatalogCollege[]> => {
        const response = await cacheGet('/catalog/colleges', 3600); // 缓存1小时
        return response.data.data;
    },
    getConcentrationsByProgram: async (programId: string): Promise<string[]> => {
        const response = await cacheGet(`/catalog/programs/${programId}/concentrations`, 3600); // 缓存1小时
        return response.data.data;
    },
    getExams: async (): Promise<CatalogExam[]> => {
        const response = await cacheGet('/catalog/exams', 3600); // 缓存1小时
        return response.data.data;
    }
}